import { S1ProcessID } from "./s1-processid";

export class CommitProcessRequest {
    processID: S1ProcessID;
    comment: string;
    layoutVersion: number;
}